import { useEffect, useRef, useState } from "react";

// Хост-экран: большой визуальный индикатор + таблица очков
export default function ReactionHost({ phase, signal, roundEnd, early, scores, players, round, maxRounds, tv }) {
  const [flash, setFlash] = useState(false);

  // Вспышка при новом сигнале
  useEffect(() => {
    if (signal) { setFlash(true); const t = setTimeout(() => setFlash(false), 200); return () => clearTimeout(t); }
  }, [signal]);

  const fs = tv ? "1.1rem" : "0.85rem";
  const sorted = Object.entries(scores || {}).sort((a, b) => b[1] - a[1]);

  // Цвет и текст центрального индикатора
  let circleColor, circleText, circleEmoji, circleGlow;
  if (phase === "waiting" || !phase) {
    circleColor = "#1a1a2b"; circleText = "Готовься..."; circleEmoji = "👁️";
    circleGlow = "none";
  } else if (phase === "signal" && signal?.real) {
    circleColor = "#0d3d1a"; circleText = "ЖМИ!"; circleEmoji = "⚡";
    circleGlow = "0 0 60px #3dffa0, 0 0 120px #3dffa055";
  } else if (phase === "signal" && !signal?.real) {
    circleColor = "#3d0d0d"; circleText = "ЛОВУШКА"; circleEmoji = "💀";
    circleGlow = "0 0 60px #ff3355, 0 0 120px #ff335555";
  } else if (phase === "result") {
    circleColor = "#1a0845"; circleText = "Результат"; circleEmoji = "🏆";
    circleGlow = "none";
  } else {
    circleColor = "#1a1a2b"; circleText = "Готовься..."; circleEmoji = "👁️";
    circleGlow = "none";
  }

  const borderColor = phase === "signal"
    ? (signal?.real ? "#3dffa0" : "#ff3355")
    : "#ffffff22";

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: tv ? "2rem" : "1.25rem" }}>

      {/* Раунд */}
      <div style={{ fontFamily: "'Fredoka One',sans-serif", color: "#aaa", fontSize: fs }}>
        Раунд {round} / {maxRounds}
      </div>

      {/* Центральный индикатор */}
      <div style={{
        width: tv ? 320 : 220, height: tv ? 320 : 220,
        borderRadius: "50%",
        background: circleColor,
        border: `6px solid ${borderColor}`,
        boxShadow: circleGlow,
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        transition: "background 0.1s, border-color 0.1s, box-shadow 0.15s",
        userSelect: "none",
      }}>
        <div style={{ fontSize: tv ? "5rem" : "3.5rem", lineHeight: 1 }}>{circleEmoji}</div>
        <div style={{
          fontFamily: "'Fredoka One',sans-serif",
          fontSize: tv ? "2rem" : "1.4rem",
          color: phase === "signal" && signal?.real ? "#3dffa0" : phase === "signal" ? "#ff3355" : "#aaa",
          textShadow: phase === "signal" ? "2px 2px 0 #000" : "none",
          marginTop: 8,
        }}>{circleText}</div>
      </div>

      {/* Результат раунда */}
      {phase === "result" && roundEnd && (
        <div style={{
          background: roundEnd.is_fake ? "#2b0d0d" : roundEnd.winner ? "#0d2b1a" : "#1a1a2b",
          border: `3px solid ${roundEnd.is_fake ? "#ff3355" : roundEnd.winner ? "#3dffa0" : "#ffffff22"}`,
          borderRadius: "1.25rem", boxShadow: "4px 4px 0 #000",
          padding: tv ? "1.25rem 2.5rem" : "0.75rem 1.5rem",
          textAlign: "center", maxWidth: tv ? 500 : 380,
        }}>
          {roundEnd.is_fake ? (
            <>
              <div style={{ fontSize: tv ? "2.5rem" : "1.8rem" }}>💀</div>
              <div style={{ fontFamily: "'Fredoka One',sans-serif", color: "#ff3355", fontSize: tv ? "1.5rem" : "1.1rem", marginTop: 4 }}>
                Ловушка! Нажавшие теряют очки
              </div>
              {Object.entries(roundEnd.round_scores || {}).length > 0 && (
                <div style={{ fontFamily: "'Nunito',sans-serif", color: "#aaa", fontSize: fs, marginTop: 6 }}>
                  {Object.entries(roundEnd.round_scores).map(([n, d]) => `${n}: ${d}`).join(" · ")}
                </div>
              )}
            </>
          ) : roundEnd.winner ? (
            <>
              <div style={{ fontSize: tv ? "2.5rem" : "1.8rem" }}>⚡</div>
              <div style={{ fontFamily: "'Fredoka One',sans-serif", color: "#3dffa0", fontSize: tv ? "1.5rem" : "1.1rem", marginTop: 4 }}>
                {roundEnd.winner} — {roundEnd.winner_ms}мс!
              </div>
              <div style={{ fontFamily: "'Nunito',sans-serif", color: "#ffe600", fontSize: fs, marginTop: 4 }}>
                +{roundEnd.round_scores?.[roundEnd.winner] || 0} очков
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: tv ? "2.5rem" : "1.8rem" }}>😴</div>
              <div style={{ fontFamily: "'Fredoka One',sans-serif", color: "#aaa", fontSize: tv ? "1.5rem" : "1.1rem", marginTop: 4 }}>
                Никто не успел
              </div>
            </>
          )}
        </div>
      )}

      {/* Фальстарт оверлей */}
      {early && (
        <div style={{
          background: "#2b0d0d", border: "2px solid #ff8c00",
          borderRadius: "0.75rem", padding: "0.4rem 1rem",
          fontFamily: "'Fredoka One',sans-serif", color: "#ff8c00", fontSize: fs,
        }}>
          ⚠️ {early.name} — фальстарт! −{early.penalty} очков
        </div>
      )}


    </div>
  );
}